import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs/Subscription';

import { UiLocaleService } from '../../../../services/ui-locale.service';
import { TranslationBundle } from '../models/translation-bundle.model';

@Pipe({
  name: 'skillContent',
  pure: false,
})
export class SkillContentTranslationPipe implements PipeTransform, OnDestroy {
  private languageChange: Subscription;

  constructor(private uiLocaleService: UiLocaleService,
              translate: TranslateService,
              changeDetector: ChangeDetectorRef) {
    this.languageChange = translate.onLangChange.subscribe(() => changeDetector.markForCheck());
  }

  ngOnDestroy(): void {
    this.languageChange.unsubscribe();
  }

  transform(source: string, translation?: TranslationBundle | null): string {
    return this.uiLocaleService.resolveContent(source, translation);
  }
}



// WEBPACK FOOTER //
// C:/work/internal-frontend/src/app/content-page/common/skill-learning/pipes/skill-content-translation.pipe.ts